<template>
  <div>
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav> -->
    <router-view />
  </div>
</template>

<style>
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: rgb(247, 243, 243);
  margin-top: 4rem;

  font-family: Arial, sans-serif;
  box-sizing: border-box;
}
#app a {
  text-decoration: none;
}
#app a:hover{
  color: #cc0000;;
}
</style>
